import { ComponentProps, FC, ReactNode } from 'react';

import { cn } from '@savgroup-front-common/primitive/lib/utils';
import { Button } from '@savgroup-front-common/primitive/ui/button';

const ACTION_BUTTON_VARIANT = 'ghost';
const DISABLED_CONTENT_COLOR = 'stext-disabled-default';
const ENABLED_CONTENT_COLOR = 'stext-muted-default';

type ControlledButtonProp = 'variant' | 'size';

interface BottomBarActionProps extends Omit<
  ComponentProps<typeof Button>,
  ControlledButtonProp
> {
  icon: ReactNode;
  label: ReactNode;
}

export const BottomBarAction: FC<BottomBarActionProps> = ({
  icon,
  label,
  className,
  disabled,
  ...props
}) => {
  const contentColor = disabled
    ? DISABLED_CONTENT_COLOR
    : ENABLED_CONTENT_COLOR;

  return (
    <Button
      variant={ACTION_BUTTON_VARIANT}
      disabled={disabled}
      className={cn('h-14 w-full flex-col gap-1 p-0', className)}
      {...props}
    >
      <span
        className={cn(
          contentColor,
          'flex h-7.5 w-15 items-center justify-center',
        )}
      >
        {icon}
      </span>
      <span
        className={cn(contentColor, 'max-w-full truncate text-xs font-medium')}
      >
        {label}
      </span>
    </Button>
  );
};
